import { render, staticRenderFns } from "./ImportStudents.vue?vue&type=template&id=6efd6202"
import script from "./ImportStudents.vue?vue&type=script&lang=js"
export * from "./ImportStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports